import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {isBrowser} from '@/utils/tools';
import './index.less';

function ToolBar({platform = '', city_no}) {
  const [path, setPath] = useState('/');
  let pathName = '/';

  useEffect(() => {
    if (isBrowser()) {
      setPath(window.location.pathname);
    }
  }, []);

  return (
    <nav className="bar bar-tab newTab">
      <Link
        to={`/${platform ? `?platform=${platform}` : ''}`}
        className={`tab-item external ${path === '/v2/' ? ' active' : ''}`}
        data-category="首页"
        data-action="菜单"
        data-name="首页"
      >
        <span className={`navIcon homeIcon`}></span>
        <span className="tab-label">首页</span>
      </Link>
      <Link
        to={`/doctorList?city_code=${city_no}&video=2`}
        className={`tab-item external${pathName.indexOf('/old/consultcenter') !== -1 ? ' active' : ''}`}
        data-category="视频"
        data-action="菜单"
        data-name="视频"
      >
        <span className={`navIcon videoIcon`}></span>
        <span className="tab-label">视频看诊</span>
      </Link>
      <Link
        to={`/teach`}
        className={`tab-item external${path === '/learn' ? ' active' : ''}`}
        data-category="学中医"
        data-action="菜单"
        data-name="学中医"
      >
        <span className={`navIcon learnIcon`}></span>
        <span className="tab-label">学中医</span>
      </Link>
      <Link
        to="/usercenter"
        className={`tab-item external${path === '/usercenter' ? ' active' : ''}`}
        data-category="个人中心"
        data-action="菜单"
        data-name="个人中心"
      >
        <span className={`navIcon userIcon`}></span>
        <span className="tab-label">个人中心</span>
      </Link>
    </nav>
  );
}

export default ToolBar;
